/**
 * Niet in het origineel: de spelleider logt in met e-mail en wachtwoord. Het origineel had
 * op /admin geen login. Het mechanisme komt uit VIP: accounts in D1, sessies in KV, een
 * uitnodiging of herstellink per mail.
 *
 * Hier staat het contract tussen de Worker en de schermen: wat de routes onder `/api/auth`
 * en `/api/spelleiders` ontvangen en teruggeven, plus de paden van de links in de mails.
 * Een fout komt altijd terug als `{ fout: string }` met een passende HTTP-status; bij een
 * afgekeurd wachtwoord staan de bezwaren er los bij in `fouten`.
 */
/** Het pad van de uitnodigingslink in de mail; de route van de client gebruikt hetzelfde. */
export const uitnodigingsPad = (token) => `/admin/uitnodiging/${encodeURIComponent(token)}`;
/** Het pad van de link in de mail van Wachtwoord vergeten. */
export const herstelPad = (token) => `/admin/wachtwoord-herstellen/${encodeURIComponent(token)}`;
/** Hoe lang een uitnodigingslink werkt. */
export const UITNODIGING_GELDIG_UREN = 24;
/** Hoe lang een herstellink werkt. In minuten: "60 minuten" leest korter dan "1 uur". */
export const HERSTEL_GELDIG_MINUTEN = 60;
/** Een e-mailadres zoals het wordt opgeslagen en vergeleken. */
export const normaliseerEmail = (email) => email.trim().toLowerCase();
/** Een ruwe controle: genoeg om tikfouten te vangen, de mail zelf is de echte toets. */
export const isEmailAdres = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normaliseerEmail(email)) && email.length <= 254;
